export default "__VITE_PUBLIC_ASSET__5385000a__"